import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_ROUTE ?? "";
const baseURL = backendUrl.replace(/\/?$/, "/");

const api = axios.create({
  baseURL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
